(function () {
  function initSwipers() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.ai-swiper').forEach(function (el) {
      if (el.dataset.aiSwiperInit === '1') return;
      var opts = {};
      try { opts = JSON.parse(el.dataset.aiSwiper || '{}'); } catch (e) { opts = {}; }
      var config = {
        slidesPerView: opts.slidesPerView || 1,
        spaceBetween: opts.spaceBetween || 16,
        loop: !!opts.loop,
        watchOverflow: true,
        breakpoints: opts.breakpoints || undefined
      };
      if (opts.autoplay) config.autoplay = { delay: 3000, disableOnInteraction: false };
      if (opts.navigation) {
        var root = el.closest('section') || document;
        config.navigation = {
          nextEl: root.querySelector('.swiper-button-next'),
          prevEl: root.querySelector('.swiper-button-prev')
        };
      }
      if (opts.pagination) {
        var root2 = el.closest('section') || document;
        config.pagination = { el: root2.querySelector('.swiper-pagination'), clickable: true };
      }
      new Swiper(el, config);
      el.dataset.aiSwiperInit = '1';
    });
  }

  function initSellingPoints() {
    document.querySelectorAll('[data-ai-selling-points]').forEach(function (root) {
      if (root.dataset.spInit === '1') return;
      root.dataset.spInit = '1';
      var slides = root.querySelectorAll('.swiper-slide');
      var bullets = root.querySelectorAll('.homepage-selling-points-pagination-bullet');
      var descs = root.querySelectorAll('.homepage-selling-points-pagination-desc-item');
      function show(i) {
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        bullets.forEach(function (b, n) { b.classList.toggle('swiper-pagination-bullet-active', n === i); });
        descs.forEach(function (d, n) { d.classList.toggle('active', n === i); });
      }
      bullets.forEach(function (b, n) {
        b.addEventListener('click', function () { show(n); });
      });
      show(0);
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-ai-tabs]').forEach(function (root) {
      if (root.dataset.tabsInit === '1') return;
      root.dataset.tabsInit = '1';
      var items = root.querySelectorAll('.tab-item');
      var panes = root.querySelectorAll('.tab-content-item');
      function show(i) {
        items.forEach(function (t, n) { t.classList.toggle('tab-item--active', n === i); });
        panes.forEach(function (p, n) { p.classList.toggle('tab-content-item--active', n === i); });
      }
      items.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      show(0);
    });
  }


  function initFeatureTabs() {
    document.querySelectorAll('[data-ai-feature-tabs]').forEach(function (root) {
      if (root.dataset.ftInit === '1') return;
      root.dataset.ftInit = '1';
      var tabs = root.querySelectorAll('.tab');
      var panes = root.querySelectorAll('.image-container');
      function show(i) {
        tabs.forEach(function (t, n) { t.classList.toggle('active', n === i); });
        panes.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      }
      tabs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      show(0);
    });
  }

  function boot() { initSwipers(); initSellingPoints(); initTabs(); initFeatureTabs(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
